import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-map',
	templateUrl: './map.page.html',
	styleUrls: ['map.page.scss'],
})
export class MapPage {
	customer = this.repository.customer;
	constructor(
		private navService: NavigationService,
		private router: Router,
		private repository: RepositoryService
	) {}
	static url = 'map';
	static readableId = ':readableId';
	static urlWithReadableId = MapPage.url + '/:readableId';

	static navigate(router: Router) {
		return router.navigateByUrl(MapPage.url);
	}
	goHome() {
		this.navService.home();
	}
	openPage(value: string) {
		if (!value) {
			return;
		}
		this.router.navigate([value]);
	}
}
